// extracted by mini-css-extract-plugin
export var row = "styles-module--row--3NS3C";
export var column = "styles-module--column--1qTrh";
export var itemWrapper = "styles-module--itemWrapper--2wzqa";
export var itemWrapperHorizontal = "styles-module--itemWrapperHorizontal--2EirM";
export var description = "styles-module--description--1roQr";
export var wrapped = "styles-module--wrapped--s2G0W";
export var containerClass = "styles-module--containerClass--3z_De";
export var ctaContainer = "styles-module--ctaContainer--3Muwr";
export var rowWrapper = "styles-module--rowWrapper--2yxl2";